import React, { useEffect, useRef, useState } from "react";
import { StatsOverview } from "./components/StatsOverview";
import { PointsRewardsCard } from "./components/PointsRewardsCard";
import { RecentInquiries } from "./components/RecentInquiries";
import { UpcomingBooking } from "./components/UpcomingBooking";
import { ResourceCenter } from "./components/ResourceCenter";
import { FeaturedCampaign } from "./components/FeaturedCampaign";

const GAP = 16; // gap-4

export const Dashboard = () => {
    const [hasActiveCampaign, setHasActiveCampaign] = useState<boolean>(true);
    const leftColRef = useRef<HTMLDivElement>(null);
    const [leftColHeight, setLeftColHeight] = useState<number>();
    const topRightRef = useRef<HTMLDivElement>(null);
    const [topRightHeight, setTopRightHeight] = useState<number>();

    useEffect(() => {
        const el = leftColRef.current;
        if (!el) return;

        const updateHeight = () => setLeftColHeight(el.offsetHeight);
        updateHeight();

        const observer = new ResizeObserver(updateHeight);
        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        const el = topRightRef.current;
        if (!el) return;

        const updateHeight = () => setTopRightHeight(el.offsetHeight);
        updateHeight();

        const observer = new ResizeObserver(updateHeight);
        observer.observe(el);
        return () => observer.disconnect();
    }, [hasActiveCampaign]);

    const noCampaignSlotHeight =
        leftColHeight != null ? Math.max(0, (leftColHeight - GAP) / 2) : undefined;

    const remainingHeight =
        leftColHeight != null && topRightHeight != null
            ? leftColHeight - topRightHeight - GAP * 2
            : undefined;
    const campaignSlotHeight =
        remainingHeight != null ? Math.max(0, remainingHeight / 2) : undefined;

    const slotHeight = hasActiveCampaign ? campaignSlotHeight : noCampaignSlotHeight;

    const slotHeightStyle = slotHeight != null
        ? ({ "--slot-h": `${slotHeight}px` } as React.CSSProperties)
        : undefined;

    return (
        <div className="flex gap-4 md:gap-6 py-2 items-start md:flex-nowrap flex-wrap">
            {/* left */}
            <div className="contents md:flex md:flex-col md:gap-4 md:w-8/12" ref={leftColRef}>
                <div className="w-full order-1 md:order-none">
                    <StatsOverview />
                </div>
                <div className="w-full order-2 md:order-none">
                    <PointsRewardsCard />
                </div>
                <div className="w-full order-6 md:order-none">
                    <ResourceCenter />
                </div>
            </div>
            {/* right */}
            <div className="contents md:flex md:flex-col md:gap-4 md:w-4/12">
                <div
                    className="bg-white rounded-2xl flex flex-col overflow-hidden w-full order-3 md:order-none md:h-[var(--slot-h)]"
                    style={slotHeightStyle}
                >
                    <UpcomingBooking />
                </div>

                {hasActiveCampaign && (
                    <div ref={topRightRef} className="w-full order-5 md:order-none">
                        <FeaturedCampaign
                            onCampaignChange={(campaign) => setHasActiveCampaign(Boolean(campaign))}
                        />
                    </div>
                )}

                <div
                    className="bg-white rounded-2xl flex flex-col overflow-hidden w-full order-4 md:order-none h-[360px] md:h-[var(--slot-h)]"
                    style={slotHeightStyle}
                >
                    <RecentInquiries title="Quotes" compact />
                </div>
            </div>
        </div>
    );
};
